import InputView from './InputView';

export default InputView;
